import React from 'react';
import BadNauheimLogo from '../../../assets/img/OrganizationLogos/BadNauheim-Logo.png';
import KemptenLogo from '../../../assets/img/OrganizationLogos/Kempten-Logo.png';
import LausitzLogo from '../../../assets/img/OrganizationLogos/MoveToLausitz-Logo.png';
import SIMALogo from '../../../assets/img/OrganizationLogos/SIMA-Logo.png';
import DietzenbachLogo from '../../../assets/img/OrganizationLogos/Dietzenbach-Logo.png';
import Rodgau from '../../../assets/img/OrganizationLogos/Rodgau-Logo.png';
import Ekom21Logo from '../../../assets/img/OrganizationLogos/Ekom21.png';
import { organization2 } from '../../../config/config'; // Using organization2 instead of organization
import BadHomburgLogo from '../../../assets/img/OrganizationLogos/BadHomburg-Logo.png';
import RastattLogo from '../../../assets/img/OrganizationLogos/Rastatt-Logo.png';
import Demo from '../../../assets/img/logo-ui-square-dark.png';
import FrankenbergLogo from '../../../assets/img/OrganizationLogos/Frankenberg-Logo.png';
import ULILogo from '../../../assets/img/OrganizationLogos/ULI-Logo.png';
import RotenburgLogo from '../../../assets/img/OrganizationLogos/Rotenburg-Logo.png';
import MobydexLogo from '../../../assets/img/OrganizationLogos/Mobidex-Logo.png';
import OffenburgLogo from '../../../assets/img/OrganizationLogos/Offenburg-Logo.png';


const logoMap: { [key: string]: string } = {
    'badnauheim': BadNauheimLogo,
    'kempten': KemptenLogo,
    'lausitz': LausitzLogo,
    'sima': SIMALogo,
    'dietzenbach': DietzenbachLogo,
    'rodgau': Rodgau,
    'movetolausitz': LausitzLogo,
    'ekom21': Ekom21Logo,
    'badhomburg': BadHomburgLogo,
    'rastatt': RastattLogo,
    'demo': Demo,
    'rotenburg': RotenburgLogo,
    'frankenberg': FrankenbergLogo,
    'uli': ULILogo,
    'mobydex': MobydexLogo,
    'offenburg': OffenburgLogo,
};

const OrganizationLogo2: React.FC = () => {
    if (!organization2 || !logoMap[organization2]) {
        return null; // Fallback for unknown organizations
    }

    const logoSrc = logoMap[organization2];


    return (
        <img
            src={logoSrc}
            alt={`${organization2} Logo`}
            style={{
                zIndex: 1000, // Ensures it is on top
                maxWidth: '100%', // Ensures it takes up the available space
                maxHeight: '300px', // Larger display
                objectFit: 'contain', // Maintains aspect ratio
            }}
        />
    );
};

export default OrganizationLogo2;
